import * as React from 'react';
import Immutable, {Map} from "immutable";

export class InstantPayoutsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
        <waffle.blocks.FilterBlock>
          <waffle.filters.BusinessApiFilter/>
          <waffle.filters.EnumFilter
              enumName='models.settlement.InstantPayoutState'
              filterKey="state"
              emptySelectedString="All States"
              defaults={this.props.defaultStateFilter}
              allowSelectMultiple={true}
          />
          <waffle.filters.PayoutAgeFilter/>
        </waffle.blocks.FilterBlock>
    )
  }
}

class FieldsToCopy {
  constructor(externalReference, time, amount, bankName, accountNumber, uuid) {
    this.externalReference = externalReference;
    this.time = time;
    this.amount = amount;
    this.bankName = bankName;
    this.accountNumber = accountNumber;
    this.payoutUUID = uuid;
  }

  getFields() {
    // These are the fields to be included when copying. Order of fields is defined here.
    if (this.orderedFields !== null && this.orderedFields !== undefined) {
      return this.orderedFields;
    }

    this.orderedFields = [
      {title: "External Reference", text: this.externalReference},
      {title: "Time Requested", text: this.time},
      {title: "Amount", text: this.amount},
      {title: "Beneficiary Bank Name", text: this.bankName},
      {title: "Beneficiary Account Number", text: this.accountNumber},
      {title: "Yoco Payout UUID", text: this.payoutUUID},
    ];

    return this.orderedFields;
  }

  getFieldsInfo() {
    let fieldsInfo = 'Use buttons on the left to copy Absa Query Info data';

    let fieldsOrdering = [];

    this.getFields().forEach(field => fieldsOrdering.push(`<dd>${field.title}</dd>`));

    fieldsInfo = fieldsInfo + `<br><br><dl><dt>Fields Order: </dt>${fieldsOrdering.join('')}</dl>`;

    fieldsInfo = `<span id="absaQueryInfoCopy" style="text-align: left;">${fieldsInfo}</span>`

    return fieldsInfo;
  }

  fieldNameAndValueAsNewlineSeparated() {
    let fields = this.getFields();

    const outputFields = [];

    fields.forEach(field => outputFields.push(`${field.title}: ${field.text}`));

    return outputFields.join('\n');
  }
}

export class InstantPayoutExternalReference extends waffle.base.BaseComponent {
  fieldsToCopy() {
    if (this.instantPayoutFields !== null && this.instantPayoutFields !== undefined) {
      return this.instantPayoutFields;
    }

    const fields = new FieldsToCopy();

    const instantPayout = Immutable.fromJS(this.props.parent);

    fields.externalReference = instantPayout.get('payoutExternalReferenceUUID');
    fields.time = moment(instantPayout.get('created')).format('YYYY/MM/DD HH:mm:ss Z', 'Africa/Johannesburg');
    fields.amount = instantPayout.getIn(['outboundBusinessPayout', 'displayAmount']);
    fields.bankName = instantPayout.getIn(['outboundBusinessPayout', 'paymentBankInfo', 'submittedBankDetails', 'institution']).titleize();
    fields.accountNumber = instantPayout.getIn(['outboundBusinessPayout', 'paymentBankInfo', 'submittedBankDetails', 'accountNumber']);
    fields.payoutUUID = instantPayout.get('uuid');

    this.instantPayoutFields = fields;

    return this.instantPayoutFields;
  }

  render() {
    const instantPayout = Immutable.fromJS(this.props.parent);

    const payoutExternalReferenceUUID = instantPayout.getIn(['payoutExternalReferenceUUID']);

    return (<div>
      {payoutExternalReferenceUUID}&nbsp;
      <a
          href='#'
          data-toggle='tooltip'
          title='Copy fields + data'
          onClick={() => {
            waffle.utils.copyToClipboard(this.fieldsToCopy().fieldNameAndValueAsNewlineSeparated());
            Utils.alert('Absa Query Info copied!', 'success');
          }}
      >
        <i className='fa fa-copy fa-fw' />
      </a>&nbsp;
      <span
          data-toggle='tooltip'
          data-html='true'
          title={this.fieldsToCopy().getFieldsInfo()}
      >
        <i className="fa fa-info-circle"></i>
      </span>&nbsp;

    </div>);
  }
}

export class BankPaymentExternalReference extends waffle.base.BaseComponent {
  fieldsToCopy() {
    if (this.bankPaymentFileds !== null && this.bankPaymentFileds !== undefined) {
      return this.bankPaymentFileds;
    }

    const fields = new FieldsToCopy();

    const bankPayment = Immutable.fromJS(this.props.parent);

    fields.externalReference = bankPayment.get('externalReferenceUUID');
    fields.time = moment(bankPayment.get('created')).format('YYYY/MM/DD HH:mm:ss Z', 'Africa/Johannesburg');
    fields.amount = bankPayment.getIn(['amount']);
    fields.bankName = bankPayment.getIn(['submittedBankDetails', 'institution']).titleize();
    fields.accountNumber = bankPayment.getIn(['submittedBankDetails', 'accountNumber']);
    fields.payoutUUID = bankPayment.getIn(['uuid']);

    this.bankPaymentFileds = fields;

    return this.bankPaymentFileds;
  }

  render() {
    const bankPayment = Immutable.fromJS(this.props.parent);

    const externalReferenceUUID = bankPayment.getIn(['externalReferenceUUID']);

    return (<div>
      {externalReferenceUUID}&nbsp;
      <a
          href='#'
          data-toggle='tooltip'
          title='Copy fields + data'
          onClick={() => {
            waffle.utils.copyToClipboard(this.fieldsToCopy().fieldNameAndValueAsNewlineSeparated());
            Utils.alert('Absa Query Info copied!', 'success');
          }}
      >
        <i className='fa fa-copy fa-fw' />
      </a>&nbsp;
      <span
          data-toggle='tooltip'
          data-html='true'
          title={this.fieldsToCopy().getFieldsInfo()}
      >
        <i className="fa fa-info-circle"></i>
      </span>&nbsp;

    </div>);
  }
}

export class BankTransferExternalReference extends waffle.base.BaseComponent {
  fieldsToCopy() {
    if (this.bankTransferFields !== null && this.bankTransferFields !== undefined) {
      return this.bankTransferFields;
    }

    const fields = new FieldsToCopy();

    const bankTransfer = Immutable.fromJS(this.props.parent);

    fields.externalReference = bankTransfer.getIn(['response', 'transactionId']);
    fields.time = moment(bankTransfer.get('created')).format('YYYY/MM/DD HH:mm:ss Z', 'Africa/Johannesburg');
    fields.amount = bankTransfer.getIn(['outboundBusinessPayout', 'displayAmount']);
    fields.bankName = bankTransfer.getIn(['targetAccount', 'institution']).titleize();
    fields.accountNumber = bankTransfer.getIn(['targetAccount', 'accountNumber']);
    fields.payoutUUID = bankTransfer.get('uuid');

    this.bankTransferFields = fields;

    return this.bankTransferFields;
  }

  render() {
    const transfer = Immutable.fromJS(this.props.parent);

    const externalReferenceUUID = transfer.getIn(['response', 'transactionId']);

    return (<div>
      {externalReferenceUUID}&nbsp;
      <a
          href='#'
          data-toggle='tooltip'
          title='Copy fields + data'
          onClick={() => {
            waffle.utils.copyToClipboard(this.fieldsToCopy().fieldNameAndValueAsNewlineSeparated());
            Utils.alert('Absa Query Info copied!', 'success');
          }}
      >
        <i className='fa fa-copy fa-fw' />
      </a>&nbsp;
      <span
          data-toggle='tooltip'
          data-html='true'
          title={this.fieldsToCopy().getFieldsInfo()}
      >
        <i className="fa fa-info-circle"></i>
      </span>&nbsp;

    </div>);
  }
}

export class SettlementEnabledIndicator extends waffle.base.BaseComponent {
  render() {
    const data = Immutable.fromJS(this.props.parent);
    const canBeSettled = data.get('canBeSettled');
    const cantSettleMessage = data.get('cantSettleMessage');

  if (canBeSettled) {
      return (
        <div className='text-info'>
          <i class='fa fa-check-circle-o fa-fw'></i>
          Yes
        </div>
      )
  }

    return (
      <div className='text-warning'>
        <i class='fa fa-exclamation-triangle fa-fw'></i>
        No: {cantSettleMessage}
      </div>
      )
  }
}

export class InstantPayoutsEligibilityIndicator extends waffle.base.BaseComponent {
  render() {
    const data = Immutable.fromJS(this.props.parent);
    const isInstantPayoutEligible = data.get('isInstantPayoutEligible');
    const instantPayoutsIneligibleMessage = data.get('instantPayoutsIneligibleMessage');

  if (isInstantPayoutEligible) {
      return (
        <div className='text-info'>
          <i class='fa fa-check-circle-o fa-fw'></i>
          Yes
        </div>
        )
  }

    return (
      <div className='text-warning'>
        <i class='fa fa-exclamation-triangle fa-fw'></i>
        No: {instantPayoutsIneligibleMessage}
      </div>
      )
  }
}

export class InstantPayoutsAvailableAmount extends waffle.base.BaseComponent {
  render() {
    const data = Immutable.fromJS(this.props.parent);
    const isInstantPayoutEligible = data.get('isInstantPayoutEligible');
    const availableForInstantPayout = data.get('availableForInstantPayout');

  if (!isInstantPayoutEligible) {
      return (
        <div className='text-warning'>
          <i class='fa fa-exclamation-triangle fa-fw'></i>
          Unavailable
        </div>
        )
  }

    return (
      <waffle.misc.Amount
        amount={availableForInstantPayout}
        alignLeft={true}
      />
      )
  }
}

export class BankTransfersFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
        <waffle.blocks.FilterBlock>
          <waffle.filters.BusinessApiFilter/>
          <waffle.filters.EnumFilter
              enumName='domains.settlement.models.TransferState'
              filterKey="state"
              emptySelectedString="All States"
              defaults={this.props.defaultStateFilter}
              allowSelectMultiple={true}
          />
        </waffle.blocks.FilterBlock>
    )
  }
}

export class DisbursementsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
        <waffle.blocks.FilterBlock>
          <waffle.filters.BusinessApiFilter/>
          <waffle.filters.EnumFilter
              enumName='domains.settlement.models.DisbursementState'
              filterKey="state"
              emptySelectedString="All States"
              defaults={this.props.defaultStateFilter}
              allowSelectMultiple={true}
          />
        </waffle.blocks.FilterBlock>
    )
  }
}